var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('UserHeader')],1),_c('v-col',{attrs:{"cols":"12"}},[(_vm.id == '/users/contributors')?_c('Contributors'):(_vm.id == '/users/designers')?_c('Designers'):_c('Users')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }